<template>
  <WizardPage
    v-if="shouldRender"
    hide-button-back
    can-navigate-forward
    :step="step"
    class="">
    <div class="text-center">
      <img
        class="text-center"
        src="@/assets/customer-image-vivantes.png">
    </div>
    <div class="body-1">
      <p class="text-center">
        Willkommen beim Bewerberportal von Vivantes.
      </p>
      <p class="text-center">
        Hier können Sie sich als Helfer*in oder Mitarbeiter*in von Vivantes für die Unterstützung in der Corona-Pandemie bewerben. Bitte füllen Sie die nachfolgenden Angaben wahrheitsgemäß aus.
      </p>
      <p class="text-center">
        Für Fragen stehen wir Ihnen gerne <b>von Montag bis Freitag</b> zur Verfügung:
      </p>
      <div style="margin: 0 33%; min-width: 160px;">
        <p class="text-left">
          Ramona Charpentier<br>
          Tel. 030 130 11 38 91<br>
          8 - 16 Uhr<br>
        </p>
        <p class="text-left">
          Gabriele Berger<br>
          Tel. 030 130 11 12 00<br>
          9 - 13 Uhr
        </p>
      </div>
      <p class="text-center">
        Bitte beachten:
        Vivantes-Mitarbeiter*innen, die bereits als Arzt/Ärztin, Pflegekraft oder im Funktionsdienst etc. in Schicht-/Wechselschichtarbeit tätig sind, wenden sich bitte direkt an Ihre Führungskraft. Vielen Dank.
      </p>
    </div>
  </WizardPage>
</template>

<script>
import WizardPage from './WizardPage'
import WizardPageMixin from './../mixins/WizardPageMixin'

export default {
  name: 'WizardPageHello',

  components: {
    WizardPage
  },

  mixins: [
    WizardPageMixin
  ]
}
</script>
